'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logger = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _wixBiLogger = require('@wix/wix-bi-logger');

var W = _interopRequireWildcard(_wixBiLogger);

var _baseUtils = require('./baseUtils');

var _WixSdkWrapper = require('../sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _iframeAppBiContext = require('@wix/iframe-app-bi-context');

var _windowWrapper = require('../sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

var omitEmails = function omitEmails(obj, str) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      obj[key] = obj[key].replace(emailRegex, str);
    }
  }
};

var BiLogger = function () {

  /* @ngInject */
  function BiLogger(wixBiArgs) {
    (0, _classCallCheck3.default)(this, BiLogger);

    this.needsGalleryType = function (evid) {
      return [401, 403, 406, 412, 500, 501, 502, 520, 521, 700, 703, 704].indexOf(evid) > -1;
    };
    this.initVisitorId();
    // predefine events
    this.biLogger = W && W.BI ? new W.BI.Logger(wixBiArgs) : false;

    try {
      this.protocol = _windowWrapper2.default.location.protocol;
      this.performance = _windowWrapper2.default.performance;
    } catch (e) {
      this.protocol = 'http:';
      this.performance = false;
    }

    this.biEvents = {
      store_banner_clicked: {
        evid: 182
      },
      add_pro_gallery: {
        evid: 400
      },
      change_settings: {
        evid: 401
      },
      mange_media_upper_panel_open: {
        evid: 402
      },
      pro_gallery_settings_load: {
        evid: 403
      },
      manage_media_set: {
        evid: 404
      },
      manage_media_text_editor_customize: {
        evid: 405
      },
      upload_media: {
        evid: 406
      },
      upload_media_error: {
        evid: 407
      },
      remove_media_from_gallery: {
        evid: 408
      },
      layouts_select: {
        evid: 409
      },
      gallery_performance: {
        evid: 410
      },
      settings_tab_navigation: {
        evid: 411
      },
      gallery_published: {
        evid: 412
      },
      // choose_provider: {
      //   evid: 420
      // },
      // activate_store_click: {
      //   evid: 421
      // },
      // media_sell_wizard_started: {
      //   evid: 422
      // },
      // set_pricing: {
      //   evid: 423
      // },
      // set_pricing_add_product_click: {
      //   evid: 424
      // },
      // set_pricing_ass_product_success: {
      //   evid: 425
      // },
      // manage_store_connect_paypal_success: {
      //   evid: 426
      // },
      // manage_store_connect_paypal_error: {
      //   evid: 427
      // },
      // manage_store_stats_click: {
      //   evid: 428
      // },
      // manage_store_my_profile_set: {
      //   evid: 429
      // },
      share: {
        evid: 500
      },
      love: {
        evid: 501
      },
      download: {
        evid: 502
      },
      info: {
        evid: 503
      },
      expand: {
        evid: 504
      },
      payment_excepted: {
        evid: 506
      },
      payment_error: {
        evid: 507
      },
      pro_gallery_load_error: {
        evid: 509
      },
      pro_gallery_loaded: {
        evid: 510
      },
      pro_gallery_error: {
        evid: 512
      },
      item_clicked: { //OOI only
        evid: 520
      },
      item_expanded: { //OOI only
        evid: 521
      },
      pro_gallery_load_uou: {
        evid: 304
      },
      select_photo: {
        evid: 600
      },
      share_group: {
        evid: 601
      },
      log_reach_level: {
        evid: 602
      },
      manageMediaClick: {
        evid: 700
      },
      storeSetUpTab: {
        evid: 702
      },
      expandSettings: {
        evid: 703
      },
      expandSettingsDone: {
        evid: 704
      },
      watermarkSettings: {
        evid: 705
      },
      watermarkEnable: {
        evid: 706
      },
      cartSettings: {
        evid: 708
      },
      cartSettingsDesignTab: {
        evid: 709
      },
      openStoreDashboard: {
        evid: 727
      },
      saveBusinessInfo: {
        evid: 728
      },
      artStore_startNow: {
        evid: 729
      },
      artStore_chooseSellingMethod: {
        evid: 730
      },
      buyNowClick: {
        evid: 800
      },
      support_question_click: {
        evid: 901
      }
    };
  }

  (0, _createClass3.default)(BiLogger, [{
    key: 'getGalleryType',
    value: function getGalleryType() {
      return _baseUtils.baseUtils.isStoreGallery() ? 'store' : 'progallery';
    }
  }, {
    key: 'track',
    value: function track(eventName, params, callback) {
      var biEvent = this.biEvents[eventName];
      if (!biEvent) {
        console.error('TRACK EVENT ERROR - No such bi event ' + eventName);
        return false;
      } else {
        return this.trackBi(biEvent, params, callback);
      }
    }
  }, {
    key: 'trackBi',
    value: function trackBi(biEvent) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments[2];

      if (!biEvent) {
        console.error('TRACK EVENT ERROR - No such bi event');
        return false;
      }

      //all the diferrenced for OOI are because we cannot get all the 'getBiContext(Wix)' field for OOI
      //Will need to handle this ASAP
      if (!this.biParams) {
        var biContext = {};
        if (!_baseUtils.baseUtils.isTest() && !_baseUtils.baseUtils.isOOI()) {
          try {
            biContext = (0, _iframeAppBiContext.getBiContext)(_WixSdkWrapper2.default);
          } catch (e) {
            console.error('getBiContext:', e);
          }
        }
        this.biParams = (0, _assign2.default)({}, {
          src: 65 //predefined wix-albums source
        });
        if (!_baseUtils.baseUtils.isOOI()) {
          this.biParams = (0, _assign2.default)(this.biParams, biContext, {
            gallery_id: this.getParam('galleryId')
          });
        } else {
          this.biParams = (0, _assign2.default)(this.biParams, {
            _msid: null,
            _instanceId: null,
            _visitorId: null
          });
        }
      }

      var evid = biEvent.evid;
      if (evid === 404) {
        omitEmails(params, '-omitted email-');
      }

      if (this.isUserOfUserEvent(evid) && _baseUtils.baseUtils.getViewModeFromCache() !== 'site') {
        return;
      }

      if (this.needsGalleryType(evid)) {
        params.galleryType = this.getGalleryType();
      }

      try {
        var defParams = biEvent.defaultParams || {};
        var logData = (0, _assign2.default)({}, defParams, params, this.biParams);
        this.biLog(evid, logData, callback);
      } catch (e) {
        console.warn('BI LOGGER ERROR!', e);
      }
    }
  }, {
    key: 'stats',
    value: function stats(stats_token, instance_id, album_id, action) {
      var value = 1;
      if (action === 'unlove') {
        value = -1;
        action = 'love';
      }

      var uniqueUUID = _baseUtils.baseUtils.generateUUID();

      (0, _axios2.default)({
        url: this.protocol + '//photographers-counters.wix.com/collector/rest/collect-js?ctToken=' + stats_token,
        method: 'post',
        data: {
          messageId: uniqueUUID,
          metrics: [{
            type: 'album',
            reportMetrics: [{
              name: action,
              value: value
            }],
            properties: {
              instance_id: instance_id,
              album_id: album_id
            }
          }]
        }
      }).then(function (data) {
        console.log('yeeee', data);
      });
    }
  }, {
    key: 'biLog',
    value: function biLog(evid, params, callback) {

      if (_baseUtils.baseUtils.isDev() || _baseUtils.baseUtils.isTest()) {
        return;
      }

      if (!this.biLogger) {
        console.warn('no biLogger, cannot log event');
        return;
      }
      if (typeof evid === 'undefined') {
        console.warn('evid is missing, cannot log event', evid, params);
        return;
      }
      if (typeof params === 'undefined') {
        console.warn('params are missing, cannot log event', evid, params);
        return;
      }

      var logData = (0, _assign2.default)({ evid: evid }, params);

      var adapter = this.getAdapter(evid);
      if (adapter !== null) {
        (0, _assign2.default)(logData, { adapter: adapter });
      }
      this.biLogger.log(logData, callback);
    }
  }, {
    key: 'isBot',
    value: function isBot() {
      return (/bot|googlebot|crawler|spider|robot|crawling|bing/i.test(navigator.userAgent)
      );
    }
  }, {
    key: 'initVisitorId',
    value: function initVisitorId() {
      var _this = this;

      //function is not working for OOI correctly
      if (_baseUtils.baseUtils.getViewModeFromCache() !== 'site' || _baseUtils.baseUtils.isOOI()) {
        return;
      }
      if (typeof _promise2.default === 'undefined') {
        console.error('promise is undefined in initVisitorId. Cant init visitor id');
        return;
      }
      var timeOut = 9000;
      var beginTime = Date.now();
      // const sessionTokenToVisitorId = s => [[0, 8], [8, 12], [12, 16], [16, 20], [20, 32]].map(i => s.slice(...i)).join('-');
      // new Promise(resolve => Wix.Activities.getUserSessionToken(resolve))
      //   .then(sessionTokenToVisitorId)
      //   .then(val => {
      new _promise2.default(function (resolve) {
        return resolve(_WixSdkWrapper2.default.Utils.getInstanceValue('aid') || _WixSdkWrapper2.default.Utils.getInstanceValue('uid'));
      }).then(function (val) {
        _this.visitorId = val;
        _this.onInitVisitorId && _this.onInitVisitorId();
        var interval = Date.now() - beginTime;
        if (interval > timeOut) {
          console.error('took over ' + timeOut + 'ms to get the visitor id', interval + 'ms');
        }
      }).catch(function (err) {
        return console.error('cant get visitorID/sessionToken', err);
      });
      setTimeout(function () {
        if (!_this.visitorId) {
          console.error('waiting ' + timeOut + 'ms for visitorID/sessionToken');
        }
      }, timeOut);
    }
  }, {
    key: 'isInRange',
    value: function isInRange(val, min, max) {
      return val >= min && val < max;
    }
  }, {
    key: 'isUserEvent',
    value: function isUserEvent(evid) {
      return !this.isUserOfUserEvent(evid);
    }
  }, {
    key: 'isUserOfUserEvent',
    value: function isUserOfUserEvent(evid) {
      return this.isInRange(evid, 500, 605) || evid === 304 || evid === 800;
    }
  }, {
    key: 'getAdapter',
    value: function getAdapter(evid) {
      var adapter = void 0;
      if (this.isUserEvent(evid)) {
        adapter = 'photo-users';
      } else if (this.isUserOfUserEvent(evid)) {
        adapter = 'photo-ugc';
      } else {
        console.error('evid', evid, 'is not user, or uou event (???)');
      }
      return adapter;
    }
  }, {
    key: 'getParam',
    value: function getParam(val) {
      var vmDefaultStringRegex = /^\$\{.*\}$/; //e.g. "${instance}" or "${some_variable}"
      var windowVal = String(_windowWrapper2.default[val]);

      if (windowVal && vmDefaultStringRegex.exec(windowVal) === null) {
        return windowVal;
      } else {
        var result = '',
            tmp = [];
        location.search
        //.replace ( "?", "" )
        // this is better, there might be a question mark inside
        .substr(1).split('&').forEach(function (item) {
          tmp = item.split('=');
          if (tmp[0] === val) {
            result = decodeURIComponent(tmp[1]);
          }
        });
        return result;
      }
    }
  }]);
  return BiLogger;
}();

var wixBiArgs = {
  defaultEventArgs: {},
  defaultErrorArgs: {},
  adapter: 'photo-users'
};

var logger = exports.logger = new BiLogger(wixBiArgs);